import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useRouter } from 'vue-router'

const STORE_NAME = 'registration'

export const useRegistrationStore = defineStore(STORE_NAME, () => {
  const regStep = ref(
    (() => {
      try {
        return JSON.parse(localStorage.getItem('regStep')) || 1
      } catch (e) {
        return 1
      }
    })()
  )

  const defaultData = ref(
    (() => {
      try {
        return (
          JSON.parse(localStorage.getItem('regData')) || {
            first_name: null,
            last_name: null,
            email: null,
            country_prefix: null,
            code: '',
            phone: ''
          }
        )
      } catch (e) {
        return {
          first_name: null,
          last_name: null,
          email: null,
          country_prefix: null,
          code: '',
          phone: ''
        }
      }
    })()
  )
  const hash = ref(
    (() => {
      try {
        return JSON.parse(sessionStorage.getItem('hash')) || null
      } catch (e) {
        return null
      }
    })()
  )
  const setHash = (value) => {
    hash.value = value
    sessionStorage.setItem('hash', JSON.stringify(hash.value))
  }
  const resetHash = () => {
    hash.value = null
    sessionStorage.removeItem('hash')
  }
  const updateData = (data) => {
    defaultData.value = { ...defaultData.value, ...data }
    localStorage.setItem('regData', JSON.stringify(defaultData.value))
  }
  const handleChangeStep = (step) => {
    regStep.value = step
    localStorage.setItem('regStep', JSON.stringify(regStep.value))
  }
  const handleCheckStep = (toStep) => {
    const router = useRouter()
    const currentStep = regStep.value
    if (toStep > currentStep) {
      router.push({ name: `Step${currentStep}` })
    }
  }

  const resetStep = () => {
    regStep.value = 1
    localStorage.setItem('regStep', JSON.stringify(regStep.value))
  }

  return {
    hash,
    defaultData,
    regStep,
    handleChangeStep,
    handleCheckStep,
    resetStep,
    updateData,
    setHash,
    resetHash
  }
})
